module.exports = __webpack_public_path__ + "img/ic_nav_favorit.41e09fb7.svg";